// Relative date keyword used in some filter queries
export const NOW = 'NOW'

const milliseconds = 'MILLISECONDS'
const seconds = 'SECONDS'
const minutes = 'MINUTES'
const hours = 'HOURS'
const days = 'DAYS'
const weeks = 'WEEKS'
const months = 'MONTHS'
const years = 'YEARS'
const dateRegex = `(\\d{4})\\-(\\d{2})\\-(\\d{2})`
const datetimeRegex = `${dateRegex}T(\\d{2}):(\\d{2}):(\\d{2}).(\\d{3})Z`
const datetimeToDatetimeRegex = `\\[${datetimeRegex} TO ${datetimeRegex}\\]`
const dateToDateRegex = `\\[${dateRegex} TO ${dateRegex}\\]`

/**
 * Matches date operations within a lucene query string. Mirrors the backend.
 * For example:
 * - '-1MONTH' or '-MONTH' to subtract 1 month
 * - '+3HOURS' to add 3 hours
 * - '/MONTH' to round the preceding date to the start of the month
 */
export const DATE_OPERATION_PATTERN = new RegExp(
  `([+-/])(\\d)?(${milliseconds}?|${seconds}?|${minutes}?|${hours}?|${days}?|${weeks}?|${months}?|${years}?)`,
  'g',
)

export const DATETIME_TO_DATETIME_PATTERN = new RegExp(
  `${datetimeToDatetimeRegex}$`,
  'g',
)
export const DATE_TO_DATE_PATTERN = new RegExp(`${dateToDateRegex}$`, 'g')
export const DATE_TIME_PATTERN = new RegExp(`${datetimeRegex}$`, 'g')
export const DATE_PATTERN = new RegExp(`${dateRegex}$`, 'g')
